import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/PremiseOrCloud.css'; // yeni CSS dosyası

const PremiseOrCloud = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const existing = localStorage.getItem("premiseOrCloud");
    if (existing) {
      navigate('/authorization');
    }
  }, [navigate]);

  const handleSelection = (selection) => {
    localStorage.setItem('premiseOrCloud', selection);
    navigate('/authorization');
  };

  return (
    <div className="overlay">
      <div className="popup-box">
        <h2>Select Environment</h2>
        <button className="premise-btn" onClick={() => handleSelection('premise')}>Premise</button>
        <button className="cloud-btn" onClick={() => handleSelection('cloud')}>Cloud</button>
      </div>
    </div>
  );
};

export default PremiseOrCloud;



// dizayn degisikligi oncesi
// import React from 'react';
// import { useNavigate } from 'react-router-dom';
// import '../../styles/Auth.css';

// const PremiseOrCloud = () => {
//   const navigate = useNavigate();

//   const handleSelection = (selection) => {
//     localStorage.setItem('premiseOrCloud', selection);
//     navigate('/authorization');
//   };

//   return (
//     <div className="premise-or-cloud-container">
//       <h2>Select Premise or Cloud</h2>
//       <button onClick={() => handleSelection('premise')}>Premise</button>
//       <button onClick={() => handleSelection('cloud')}>Cloud</button>
//     </div>
//   );
// };

// export default PremiseOrCloud;
